














import Vue from 'vue'

export default Vue.extend({
  name: 'compendium-search-bar',
  data: () => ({
    searchText: '',
  }),
  mounted() {
    const vm = this
    vm.$mousetrap.bind(['ctrl+f', '/'], () => {
      ;(vm.$refs.input as HTMLElement).focus()
    })
  },
  methods: {
    search() {
      this.$router.push(`/compendium/search?search=${this.searchText}`)
    },
  },
})
